/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWebhookConfiguration } from '../../models/create-webhook-configuration';
import { KeyType } from '../../models/key-type';
import { WebhookCreatedResponse } from '../../models/webhook-created-response';

export interface PostAdministrationOrganizationWebhook$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
      body: CreateWebhookConfiguration
}

export function postAdministrationOrganizationWebhook(http: HttpClient, rootUrl: string, params: PostAdministrationOrganizationWebhook$Params, context?: HttpContext): Observable<StrictHttpResponse<WebhookCreatedResponse>> {
  const rb = new RequestBuilder(rootUrl, postAdministrationOrganizationWebhook.PATH, 'post');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WebhookCreatedResponse>;
    })
  );
}

postAdministrationOrganizationWebhook.PATH = '/administration/organizations/{organizationKey}/webhooks';
